//https://github.com/microsoft/ApplicationInsights-JS/blob/master/API-reference.md
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const appInsights = new ApplicationInsights({
  config: {
    connectionString:
      "InstrumentationKey=27cf03f7-75df-4fb3-9015-ec5bc7e668de;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/",
    // Local dev shares the PRODUCTION App Insights component, so a dev session's
    // browser errors land in the same stream as real users'. On 2026-08-13 a Vite
    // hot-reload TDZ (`MAX_COLLECTION_CHIPS is not defined`, 81 events from
    // localhost in two seconds) read as a regression from the v2.9.66 deploy
    // during the post-deploy check - the one moment a false positive costs most.
    //
    // Disabling the sender rather than skipping loadAppInsights(): services/logging.ts
    // makes six calls (trackException, trackPageView, setAuthenticatedUserContext,
    // addTelemetryInitializer, clearAuthenticatedUserContext) and those throw on an
    // uninitialized core, so skipping the load would trade telemetry noise for
    // dev-only crashes. This keeps the whole API surface live and sends nothing.
    disableTelemetry: import.meta.env.DEV,
  },
});

appInsights.loadAppInsights();

export default appInsights;
